<template>
  <div>
    <page-header>Партнёры</page-header>
    <v-data-table
      :headers="headers"
      :items="items"
      class="elevation-1 mb-60"
      
      :loading="loading"
      :options.sync="options"
    >
      <template v-slot:item.name="{ item }">
        <router-link :to="`/partners/${item.id}`">{{ item.name }}</router-link>
      </template>
      <template v-slot:item.goodsCount="{ item }">
        <router-link :to="`/partners/${item.id}/goods`">{{
          item.goodsCount
        }}</router-link>
      </template>
      <template v-slot:item.active="{ item }">
        <v-icon :color="item.active ? 'green' : 'red'"
          >mdi-circle-medium</v-icon
        >
      </template>
      <template v-slot:item.manager="{ item }">
        <router-link :to="`/users/${item.manager.id}`">{{
          item.manager.name
        }}</router-link>
      </template>

      <template v-slot:item.date="{ item }">
        {{ new Date(item.date * 1000).toLocaleDateString() }}
      </template>

      <template v-slot:item.lastImport="{ item }">
        {{
          item.lastImport
            ? new Date(item.lastImport * 1000).toLocaleString()
            : "–"
        }}
      </template>

      <template v-slot:item.report="{ item }">
        <v-btn icon @click="showDialog(item.id)"><v-icon color="green">mdi-file-excel</v-icon></v-btn>
      </template>
    </v-data-table>

    <v-btn
      color="red"
      dark
      bottom
      right
      fixed
      fab
      @click="$router.push('/partners/new')"
    >
      <v-icon>mdi-plus</v-icon>
    </v-btn>

    <v-dialog v-model="reportDialog" width="300">
      <v-card>
        <v-card-title class="text-subtitle-2 align-center grey lighten-2">
          <div class="align-center">
            <span v-if="reportDates[0]">{{ reportDates[0] | toDate }}</span><span v-if="reportDates[1]"> - {{ reportDates[1] | toDate }}</span>
          </div>
          <v-btn @click="reportDialog = false" icon style="margin-left:auto"><v-icon>mdi-close</v-icon></v-btn>
        </v-card-title>
        <v-date-picker
            v-model="reportDates"
            no-title
            range
          ></v-date-picker>
        <v-card-actions class="justify-center">
          <v-btn :disabled="!datesChoosen" color="primary" @click="getReport">Скачать</v-btn>
          <a ref="downloadlink" :href="url" download="report.csv" style="display:none;"></a>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </div>
</template>

<script>
import axios from "axios";
import api from "../api";
import store from "../store";
import PageHeader from "../components/PageHeader";

export default {
  components: {
    PageHeader
  },
  data() {
    return {
      url: "",
      reportDates: [],
      reportDialog: false,
      reportItemId: 0,
      items: [],
      options: {},
      loading: false,
      allheaders: [
        {
          text: "Партнёр",
          value: "name"
        },
        {
          text: "Статус",
          value: "active"
        },
        {
          text: "Товары",
          value: "goodsCount"
        },
        {
          text: "Последний импорт",
          value: "lastImport"
        },
        {
          text: "Дата регистрации",
          value: "date"
        },
        {
          text: "Отчёт",
          value: "report"
        }
      ]
    };
  },
  watch: {
    options: {
      handler() {
        this.getList();
      }
    }
  },
  computed: {
    isAdmin() {
      return ["admin", "sv"].indexOf(store.currentUser.type) >= 0;
    },
    headers() {
      let headers = this.allheaders;

      if (this.isAdmin) {
        headers.push({
          text: "Менеджер",
          value: "manager"
        });
      }

      return headers;
    },
    datesChoosen() {
      return this.reportItemId && this.reportDates.length == 2;
    },
    datesSorted() {
      return this.reportDates.map(date => new Date(date).getTime()).sort( (a,b) => a-b )
    }
  },
  methods: {
    getList: function() {
      this.loading = true;
      axios
        .get(api.partners, {
          params: {
            page: this.options.page,
            "per-page":
              this.options.itemsPerPage > 0 ? this.options.itemsPerPage : 1000
          }
        })
        .then(resp => {
          this.items = resp.data;
        })
        .catch(err => {
          store.snackbar = true;
          store.snackbarSuccess = false;
          store.snackbarMessage = err.message;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    showDialog(id) {
      this.reportItemId = id;
      this.reportDialog = true;
    },
    getReport() {
      axios.post(api.report, {
        partnerId: this.reportItemId,
        from: this.datesSorted[0] / 1000,
        to: this.datesSorted[1] / 1000
      }, {
        responseType: 'blob'
      })
      .then(resp => {
        this.url = window.URL.createObjectURL(resp.data)
        this.$refs.downloadlink.click()
      })
    }
  }
};
</script>

<style></style>
